export enum ErrorEventType {
    Timeout = "Timeout",
    SessionExpired = "SessionExpired",
    FatalError = "FatalError"
  }
  
  export enum NotificationEventType {
    Successful = "Successful",
    Warning = "Warning",
    Error = "Error"
  }
  
  
  export class ApiErrorEvent {
    public readonly errorType: ErrorEventType; // Timeout | SessionExpired | FatalError
    public readonly webComponentName: string;
  
    constructor(errorType: ErrorEventType, webComponentName: string) {
      this.errorType = errorType;
      this.webComponentName = webComponentName;
    }
    
  }
  
  export class NotificationEvent {
    public readonly eventType: NotificationEventType;  // Successful | Warning | Error
    public readonly message: string;
  
    constructor(eventType: NotificationEventType, message: string) {
      this.eventType = eventType;
      this.message = message;
    }
  }
  